module.exports = __webpack_public_path__ + "img/add_new_books_view.4bd669a6.png";